<template>
 <div class="product-title" :class="{'isLeft':isLeft,'isRight':isRight}">
   <h3 class="main-title">{{mainTitle}}</h3>
   <div class="sub-title">{{subTitle}}</div>
 </div>
</template>

<script>
 export default {
  name: 'productTitle',
   props: {
    mainTitle: String,
     subTitle: String,
     isLeft: Boolean,
     isRight: Boolean,
   }

 }
</script>

<style lang="scss">
@import "ProductTitle";
</style>
